// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/sass/main.scss
// module id = 72
// module chunks = 0